<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-1 flex-col items-center justify-center h-full bg-white dark:bg-n-solid-1 px-6"
  >
    <span class="i-lucide-inbox size-12 text-n-slate-6 mb-4" />
    <p class="text-base text-n-slate-11 text-center mb-0">
      {{ t('EVENT_INBOX.EMPTY') }}
    </p>
  </div>
</template>
